import styled from 'styled-components'

export const Container = styled.div`
  display: inline-block;
  vertical-align: middle;
`

export const Label = styled.label<{ disabled: boolean }>`
  display: flex;
  align-items: center;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  position: relative;
`

export const HiddenCheckbox = styled.input`
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`

export const CheckMark = styled.span<{ checked: boolean; size: 'small' | 'medium' }>`
  width: ${({ size }) => (size == 'small' ? 4 : 5)}px;
  height: ${({ size }) => (size == 'small' ? 6 : 10)}px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  visibility: ${({ checked }) => (checked ? 'visible' : 'hidden')};
  margin-bottom: 2px;
`

export const StyledCheckbox = styled.div<{
  checked: boolean
  disabled: boolean
  'aria-invalid'?: boolean
  size: 'small' | 'medium'
}>`
  width: ${({ size }) => (size == 'small' ? 14 : 20)}px;
  height: ${({ size }) => (size == 'small' ? 14 : 20)}px;

  background: ${({ checked }) => (checked ? '#4D4BE7' : '#ffffff')};
  border: 2px solid
    ${({ disabled, checked }) => {
      if (disabled) return '#d9d9d9'
      return checked ? '#4D4BE7' : '#d9d9d9'
    }};
  opacity: ${({ disabled }) => (disabled ? 0.8 : 1)};
  border-radius: 4px;
  transition: all 150ms ease;

  display: flex;
  align-items: center;
  justify-content: center;

  ${Label}:hover & {
    border-color: ${({ disabled }) => (disabled ? '#d9d9d9' : '#4D4BE7')};
  }

  &:focus-within {
    outline: 2px solid #4d4be7;
    outline-offset: 2px;
  }
`

export const LabelText = styled.span<{
  disabled: boolean
  'aria-invalid'?: boolean
}>`
  margin-left: 8px;
  color: ${({ disabled }) => (disabled ? '#d4d4d8' : '#333333')};
  font-size: 14px;
  font-weight: 400;
  user-select: none;
  transition: color 150ms ease;

  ${Label}:hover & {
    color: ${({ disabled }) => (disabled ? '#d4d4d8' : '#4D4BE7')};
  }
`
